import { ActionTree } from 'vuex';
import { EditorViewAction } from '@/editor/editor-block-view/store/editor-view.constants';
import { IRootState } from '@signing-page/store/store';
import { EditorViewService } from '@/editor/editor-block-view/api/services/editor-view.service';
import { UpdateInputFieldRequest } from '@/editor/editor-block-view/api/services/types/requests';

export const actions: ActionTree<{}, IRootState> = {
  async [EditorViewAction.UpdateInputValue](_, payload: UpdateInputFieldRequest) {
    try {
      await EditorViewService.updateEditorInputField(payload);
    } catch (error) {
      console.error(error);
    }
  },
};
